import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { FaInfoCircle } from 'react-icons/fa';

export const BetaModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center; 
    z-index: 2001;
`;

export const ModalContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 2001;
    width: 90%;
    max-width: 900px;
    position: relative;
    overflow: hidden; 

    @media screen and (max-width: 490px){
        width: 95%;
        max-height: 85vh; 
        padding: 15px 15px 5px 15px;
    }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 98;
  margin: 12px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  width: 100%;
  max-width: 800px;
  flex: 1; 
  overflow-y: auto; 
  padding-bottom: 15px;
  min-height: 400px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start; 
    min-height: none;
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 20px;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;

   @media screen and (max-width: 480px) {
    padding-bottom: 20px;
    margin-left: 0px;
  }
`;

export const TopLine = styled.div`
  color: #cc8f2d;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  min-height: 20px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 24px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? '#f7f8fa' : '#010606')};
  min-height: 30px;

  @media screen and (max-width: 480px) {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    min-height: 40px;
  }
`;

export const Subtitle = styled.p`
  justify-content: center;
  align-items: center;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 20px;
  color: ${({ darkText }) => (darkText ? '#010606' : '#fff')};

  @media screen and (max-width: 480px) {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    min-height: auto; 
  }
`;

export const ImgWrap = styled.div`
  max-width: 400px;
  max-height: 300px;
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  @media screen and (max-width: 480px) {
    height: 160px; 
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;

  @media screen and (max-width: 480px) {
    margin-left: 0px;
  }
`;

export const InfoLabel = styled.span`
  background: none;
  border: none;
  margin-right: 8px;
  font-size: 16px;
  color: #cc8f2d;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 4px; 
  
  &:hover {
    color: #000; 
  }

  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const StyledIconInfo = styled(FaInfoCircle)`
  color: #cc8f2d;

  &:hover {
    color: #000;
    transition: 0.2s ease-in-out;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  max-width: 100px;
`;

export const CurrencySymbol = styled.span`
  position: absolute;
  left: 12px;
  font-size: 15px;
  color: #666666;
  pointer-events: none; 
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 10px 10px 28px;
  border-color: #101522;
  border-radius: 4px;
  font-size: 15px;
  box-sizing: border-box;
  max-height: 32px;

  &:focus {
    outline: none;
    border: 2px solid #cc8f2d;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: white;
  padding: 15px 0 10px 0;
  z-index: 100;
  flex-shrink: 0; 
  border-top: 1px solid #f0f0f0; 
`;

export const FormButton = styled.button`
  border-radius: 4px;
  background: ${({ disabled }) => (disabled ? 'transparent' : 'black')};
  white-space: nowrap;
  padding: 2px 8px;
  color: ${({ disabled }) => (disabled ? 'transparent' : '#cc8f2d')};
  font-size: 20px;
  outline: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  transition: all 0.3s ease;
  min-width: 100px;
  margin: 0 10px;
  text-align: center;
  
  &:hover {
    background: transparent;
    color: ${({ disabled }) => (disabled ? 'transparent' : '#000')};
  }
`;

export const ModalCloseButton = styled.button`
  border-radius: 4px;
  background: black;
  white-space: nowrap;
  padding: 2px 8px;
  color: #cc8f2d;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  margin: 0 10px;
  text-align: center;
  
  &:hover {
    background: transparent;
    color: #000;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`;
